import { apiService } from "@/common/api.service.js";

export default {
    // Waterfall Chart Data
    waterfallOpportunities() {
      let endpoint = `/api/waterfall-data/`;
      return apiService(endpoint);
    },

    updateWaterfallCharts(payload) {
      let endpoint = `/api/update-waterfall-charts/`;
      return apiService(endpoint, "POST", payload);
    },
}